import React, { useState, useEffect } from 'react';
import styles from './RejectionNote.module.css';
import { useParams } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import RejectButton from '../../components/RejectButton/RejectButton';
import RequestEditButton from '../../components/RequestEditButton/RequestEditButton';
import Modal from 'react-modal';

import useApproval from '../../hooks/useApproval';

export default function RejectionNote() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [rejected, setRejected] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [requested, setRequest] = useState(false);
    const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);
    const [rejectionNote, setRejectionNote] = useState('');

    const invoiceID = sessionStorage.getItem("selectedInvoiceID");
    const {rejectInvoice, modifyInvoice} = useApproval(invoiceID);
    

    const customModalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'var(--theme-bg-elevated)',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
    };

    useEffect(() => {
        if (rejected) {
            setIsRejectModalOpen(true);
        } else if (requested) {
            setIsRequestModalOpen(true);
        }
    }, [rejected, requested]);

    const closeModal = () => {
        sessionStorage.removeItem("selectedInvoiceID");
        navigate('/approve-invoices');
        setIsRejectModalOpen(false);
        setIsRequestModalOpen(false);
    };

    const goBack = () => {
        sessionStorage.removeItem("modification");
        sessionStorage.removeItem("oldValues");
        sessionStorage.removeItem("originalAmount");
        sessionStorage.removeItem("currency");
        window.history.back();
    };

    const clearDraftSession = () => {
        sessionStorage.removeItem("modification");
        sessionStorage.removeItem("oldValues");
        sessionStorage.removeItem("originalAmount");
        sessionStorage.removeItem("currency");
    };

    const handleRequestEdit = async () => {
        let modification = JSON.parse(sessionStorage.getItem("modification") || "{}");
        let oldValues = JSON.parse(sessionStorage.getItem("oldValues") || "{}");
        let originalAmount = sessionStorage.getItem("originalAmount");
        let currency = sessionStorage.getItem("currency");
        let invoiceID = sessionStorage.getItem("selectedInvoiceID");

        if (!invoiceID) {
            alert("Unable to request edit: missing invoice ID.");
            return;
        }

        if (rejectionNote !== "") {
            modification["rejectNote"] = rejectionNote;
        } else {
            delete oldValues.rejectNote;
        }

        if (Object.keys(modification).length !== 0) {
            modification["invoiceID"] = invoiceID.toString();
            modification["oldValues"] = JSON.stringify(oldValues);
            if (originalAmount != null) {
                modification["originalAmount"] = originalAmount.toString();
            }
            if (currency != null) {
                modification["currency"] = currency;
            }
            try {
                await modifyInvoice(modification);
            } catch (err) {
                console.error("Error modifying invoice:", err);
                return;
            }
        }

        try {
            await rejectInvoice(invoiceID, rejectionNote, true);
            setRequest(true);
            clearDraftSession();
        } catch (error) {
            console.error("Error requesting invoice edit:", error);
        }
    };

    const handleReject = async() => {
        let modification = JSON.parse(sessionStorage.getItem("modification") || "{}");
        let oldValues = JSON.parse(sessionStorage.getItem("oldValues") || "{}");
        let originalAmount = sessionStorage.getItem("originalAmount");
        let currency = sessionStorage.getItem("currency");
        let invoiceID = sessionStorage.getItem("selectedInvoiceID");

        if (!invoiceID) {
            alert("Unable to reject invoice: missing invoice ID.");
            return;
        }

        console.log("Rejection Note:", rejectionNote);
        if (rejectionNote !== "") {
            //If there is a rejection note, include it in modifications
            modification["rejectNote"] = rejectionNote;
        } else {
            // If there is no rejection note, no need to save old value
            delete oldValues.rejectNote;
        }

        if (Object.keys(modification).length !== 0) {
            // Required arguments
            modification["invoiceID"] = invoiceID.toString();
            modification["oldValues"] = JSON.stringify(oldValues);
            if (originalAmount != null) {
                modification["originalAmount"] = originalAmount.toString();
            }
            if (currency != null) {
                modification["currency"] = currency;
            }
            try {
                await modifyInvoice(modification);
                try {
                    await rejectInvoice(invoiceID, rejectionNote);
                    setRejected(true);
                    clearDraftSession();
                } catch (error) {
                    console.error("Error rejecting invoice:", error);
                }
            } catch(err) {
                console.error("Error modifying invoice:", err);
            }
            
        } else {
            try {
                await rejectInvoice(invoiceID, rejectionNote);
                setRejected(true);
                clearDraftSession();
            } catch (error) {
                console.error("Error rejecting invoice:", error);
            }
        }
        
        
    };

    const handleSubmit = () => {
        console.log('Note included');
    };


    return (
        <div className={styles.pageContainer}>
            <div className={styles.header}>

                <div style={{ width: "30px" }}>
                    <IconButton onClick={goBack} sx={{ color: 'var(--theme-text)' }}>
                        <ArrowBackIosNew />
                    </IconButton>
                </div>
                <div className={styles.title}>Reject Invoice no. {id}</div>
            </div>

            <div className={styles.content}>
                <div className={styles.label}>
                    Reject Note
                </div>

                <div className={styles.note}>
                    <form onSubmit={handleSubmit}>
                        <textarea
                            rows="10"
                            cols="90"
                            className={styles.noteInput}
                            value={rejectionNote}
                            onChange={(event) => setRejectionNote(event.target.value)}
                        />
                    </form>
                </div>
            </div>

            <div className={styles.actionButton}>
                <div style={{ padding: "0 10px" }}> <RequestEditButton handleRequestEdit={handleRequestEdit} /> </div>
                <div style={{ padding: "0 10px" }}> <RejectButton handleReject={handleReject} /> </div>
            </div>
            <Modal
                isOpen={isRejectModalOpen}
                onRequestClose={closeModal}
                style={customModalStyles}
                contentLabel="Submission Result"
            >
                <button className={styles.closeButton} onClick={closeModal}>
                    <span className={styles.closeIcon}>x</span>
                </button>
                <h2 className={styles.successMessage}>You have successfully rejected the invoice.</h2>
            </Modal>

            <Modal
                isOpen={isRequestModalOpen}
                onRequestClose={closeModal}
                style={customModalStyles}
                contentLabel="Submission Result"
            >
                <button className={styles.closeButton} onClick={closeModal}>
                    <span className={styles.closeIcon}>x</span>
                </button>
                <h2 className={styles.successMessage}>You have successfully requested an edit to this invoice.</h2>
            </Modal>

        </div>
    )
}
